export const MUSIC_SEO_ARTISTS = Object.freeze({
  'fleetwood-mac': Object.freeze({ name: 'Fleetwood Mac', kind: 'Group', area: 'United Kingdom', active: '1967-present', relation: 'British-American rock band', source: 'MusicBrainz' }),
  queen: Object.freeze({ name: 'Queen', kind: 'Group', area: 'United Kingdom', active: '1970-present', relation: 'British rock band', source: 'MusicBrainz' }),
  'the-beatles': Object.freeze({ name: 'The Beatles', kind: 'Group', area: 'United Kingdom', active: '1960-1970', relation: 'English rock band', source: 'MusicBrainz' }),
  'david-bowie': Object.freeze({ name: 'David Bowie', kind: 'Person', area: 'United Kingdom', active: '1947-2016', relation: 'Singer, songwriter and musician', source: 'MusicBrainz' }),
});

export const MUSIC_SEO_RELEASE_GROUPS = Object.freeze({
  rumours: Object.freeze({ title: 'Rumours', artist: 'Fleetwood Mac', kind: 'Album', year: 1977, source: 'MusicBrainz' }),
  'a-night-at-the-opera': Object.freeze({ title: 'A Night at the Opera', artist: 'Queen', kind: 'Album', year: 1975, source: 'MusicBrainz' }),
});

const DISCOGRAPHY = Object.freeze({
  'fleetwood-mac': Object.freeze([{ title: 'Fleetwood Mac', year: 1975 }, { title: 'Rumours', year: 1977 }, { title: 'Tusk', year: 1979 }]),
  queen: Object.freeze([{ title: 'Queen', year: 1973 }, { title: 'A Night at the Opera', year: 1975 }, { title: 'News of the World', year: 1977 }]),
});

function safeSlug(value) { return typeof value === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value) ? value : null; }
function artistCard(a) { return { name: a.name, sub: `${a.kind} · ${a.area}`, note: a.relation, meta: `Active ${a.active}`, source: a.source }; }

export function buildMusicSeoPage(kind, params = {}) {
  if (kind === 'artist') {
    const slug = safeSlug(params.slug);
    const a = slug && MUSIC_SEO_ARTISTS[slug];
    if (!a) return null;
    return { kind, title: a.name, description: `Source-aware music information, groups and discography chronology for ${a.name}.`, entities: [artistCard(a)] };
  }
  if (kind === 'release-group') {
    const slug = safeSlug(params.slug);
    const rg = slug && MUSIC_SEO_RELEASE_GROUPS[slug];
    if (!rg) return null;
    return { kind, title: `${rg.title} (${rg.artist})`, description: `Release-group information for ${rg.title} by ${rg.artist}.`, entities: [{ name: rg.title, sub: `${rg.kind} · ${rg.artist}`, meta: `First release ${rg.year}`, source: rg.source }] };
  }
  if (kind === 'compare') {
    const leftSlug = safeSlug(params.left); const rightSlug = safeSlug(params.right);
    const left = leftSlug && MUSIC_SEO_ARTISTS[leftSlug]; const right = rightSlug && MUSIC_SEO_ARTISTS[rightSlug];
    if (!left || !right || leftSlug === rightSlug) return null;
    return { kind, title: `${left.name} vs ${right.name}`, description: `A factual comparison of ${left.name} and ${right.name} by type, origin and active years.`, entities: [artistCard(left), artistCard(right)] };
  }
  if (kind === 'discography') {
    const slug = safeSlug(params.slug);
    const a = slug && MUSIC_SEO_ARTISTS[slug]; const albums = slug && DISCOGRAPHY[slug];
    if (!a || !albums) return null;
    return { kind, title: `${a.name} discography`, description: `Release-group chronology for ${a.name}.`, answer: `${a.name} release groups shown in first-release chronology.`, entities: albums.map((album) => ({ name: album.title, sub: 'Release group · Album', meta: `First release ${album.year}`, source: 'MusicBrainz' })) };
  }
  return null;
}

export function musicSeoPaths() {
  return [
    ...Object.keys(MUSIC_SEO_ARTISTS).map((slug) => `/music-explorer/artist/${slug}`),
    ...Object.keys(MUSIC_SEO_RELEASE_GROUPS).map((slug) => `/music-explorer/release-group/${slug}`),
    ...Object.keys(DISCOGRAPHY).map((slug) => `/music-explorer/discography/${slug}`),
  ];
}
